export const processEscapeStrings = (barcode, scanPackSettings) => {
  if (!barcode) {
    return barcode;
  }

  let processedBarcode = barcode;

  const removeEscapeString = (input, escapeString) => {
    if (input && input.includes(escapeString) && escapeString !== '') {
      const tempIndex = input.indexOf(escapeString);
      input = input.slice(0, tempIndex);
    }
    return input.endsWith(' ') ? input.trimRight() : input;
  };

  if (scanPackSettings?.first_escape_string_enabled) {
    processedBarcode = removeEscapeString(processedBarcode, scanPackSettings.escape_string);
  }

  if (scanPackSettings?.second_escape_string_enabled) {
    processedBarcode = removeEscapeString(processedBarcode, scanPackSettings.second_escape_string);
  }

  return processedBarcode;
};

export const removeStringFromBarcode = (barcode, removalString) => {
  if (barcode && barcode.includes(removalString) && removalString !== '') {
    const tempIndex = barcode.indexOf(removalString);
    return barcode.slice(0, tempIndex);
  }
  return barcode;
};

export const processGS1Barcode = (barcode) => {
  if (!barcode) {
    return barcode;
  }

  // Human-readable text such as (01)12345678901231(10)LOT789 matches once the parentheses are dropped.
  const rawBarcode = /^\(01\)\d{14}/.test(barcode) ? barcode.replace(/[()]/g, '') : barcode;
  const gs1BarcodeRegex = /^01(\d{14})((15\d{6})|(21\w{1,20})|(11\d{6})|(17\d{6})|(10\w{1,20})).*/;
  const gs1Match = rawBarcode.match(gs1BarcodeRegex);

  if (gs1Match) {
    const modifiedStr = rawBarcode.slice(2);
    const originalBarcode = modifiedStr.substring(0, 14);
    return originalBarcode;
  }
  
  return barcode;
};

export const processBarcodeInput = (barcode, scanPackSettings, isClickScan = false) => {
  if (!barcode || isClickScan) {
    return barcode;
  }

  let processedBarcode = barcode;

  processedBarcode = processGS1Barcode(processedBarcode);

  if (scanPackSettings?.escape_string_enabled) {
    processedBarcode = processEscapeStrings(processedBarcode, scanPackSettings);
  }

  if (scanPackSettings?.string_removal_enabled && scanPackSettings?.string_removal) {
    processedBarcode = removeStringFromBarcode(processedBarcode, scanPackSettings.string_removal);
  }

  return processedBarcode;
};

